import styled from "styled-components";

export const ServiceRequestItemStyles = styled.div`
  display: flex;
  align-items: center;

  .Id {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.1px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }

  .userText {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.1px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }

  .serviceTypeText {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.1px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }

  .date {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 0.1px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
  }

  .msgs {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.error[500]};
  }

  .actionButtons {
    border-radius: 6px;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    text-align: center;
    padding: 8px 16px;
  }
`;
